<template>
	<div class="PlanesNuevo">
		<md-layout md-flex="100" md-align="center">
			<md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="90" md-flex-large="70" md-flex-xlarge="60">
				<md-card class="w-100">
					<md-card-header>
						<div class="md-title">Editar plan de pago</div>
						<div class="md-subhead">Los campos marcados con * son obligatorios</div>
					</md-card-header>
					<md-card-content>
						<md-layout md-flex="100" md-gutter="24">
							<md-layout md-column md-flex="100">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre }">
									<label>Nombre del plan</label>
									<md-input v-model="plan.nombre_pln" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_salario_qnal }">
									<label>Salario semanal</label>
									<md-input v-model="plan.salario_qnal_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_falta_just }">
									<label>Falta justificada</label>
									<md-input v-model="plan.falta_just_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_falta_injust }">
									<label>Falta injustificada</label>
									<md-input v-model="plan.falta_injust_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_permiso }">
									<label>Permiso</label>
									<md-input v-model="plan.permiso_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_permiso_falle }">
									<label>Permiso fallecimiento</label>
									<md-input v-model="plan.permiso_falle_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_permiso_naci }">
									<label>Permiso nacimiento</label>
									<md-input v-model="plan.permiso_naci_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_hora_tie_ext }">
									<label>Hora de tiempo extra</label>
									<md-input v-model="plan.hora_tie_ext_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_tie_ext }">
									<label>Tiempo extra</label>
									<md-input v-model="plan.tie_ext_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_doble_turno }">
									<label>Doble turno</label>
									<md-input v-model="plan.doble_turno_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_dia_festivo }">
									<label>Día festivo</label>
									<md-input v-model="plan.dia_festivo_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_dia_tresuno }">
									<label>Día 28</label>
									<md-input v-model="plan.dia_tresuno_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
							<md-layout md-column md-flex-xsmall="50" md-flex-small="50" md-flex-medium="25" md-flex-large="25" md-flex-xlarge="25">
								<md-input-container v-bind:class="{ 'md-input-invalid': val.v_dia_dosocho }">
									<label>Día 31</label>
									<md-input v-model="plan.dia_dosocho_pnh" type="number" min="0" step=".01" required></md-input>
								</md-input-container>
							</md-layout>
						</md-layout>
					</md-card-content>
					<md-card-actions>
						<md-button @click.native="regresarAPlanes()">Cancelar</md-button>
						<md-button class="md-primary md-raised" @click.native="actualizarPlan()">Guardar cambios</md-button>
					</md-card-actions>
				</md-card>
			</md-layout>
		</md-layout>
	</div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "PlanesNuevo",
  methods: {
    regresarAPlanes() {
      this.$router.push("/planes");
    },
    obtenerPlan() {
      if (this.$route.params.id) {
        this.$http
          .post("planes", {
            data: this.plan,
            token: this.$session.get("token"),
            id: this.$route.params.id
          })
          .then(
            response => {
              if (response.status === 200 && "plan" in response.body) {
                this.plan = response.body.plan;
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right",
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
                this.$router.push("/inicio");
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
              this.$router.push("/inicio");
            }
          );
      }
    },
    actualizarPlan() {
      if (this.validarCamposPlan()) {
        this.$http
          .post("planes/actualizar", {
            data: this.plan,
            token: this.$session.get("token"),
            id: this.$route.params.id
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
                this.$router.push("/planes");
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right",
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarCamposPlan() {
      !this.plan.salario_qnal_pnh
        ? (this.val.v_salario_qnal = true)
        : (this.val.v_salario_qnal = false);
      !this.plan.falta_just_pnh
        ? (this.val.v_falta_just = true)
        : (this.val.v_falta_just = false);
      !this.plan.falta_injust_pnh
        ? (this.val.v_falta_injust = true)
        : (this.val.v_falta_injust = false);
      !this.plan.permiso_pnh
        ? (this.val.v_permiso = true)
        : (this.val.v_permiso = false);
      !this.plan.permiso_falle_pnh
        ? (this.val.v_permiso_falle = true)
        : (this.val.v_permiso_falle = false);
      !this.plan.permiso_naci_pnh
        ? (this.val.v_permiso_naci = true)
        : (this.val.v_permiso_naci = false);
      !this.plan.hora_tie_ext_pnh
        ? (this.val.v_hora_tie_ext = true)
        : (this.val.v_hora_tie_ext = false);
      !this.plan.tie_ext_pnh
        ? (this.val.v_tie_ext = true)
        : (this.val.v_tie_ext = false);
      !this.plan.doble_turno_pnh
        ? (this.val.v_doble_turno = true)
        : (this.val.v_doble_turno = false);
      !this.plan.dia_festivo_pnh
        ? (this.val.v_dia_festivo = true)
        : (this.val.v_dia_festivo = false);
      !this.plan.dia_tresuno_pnh
        ? (this.val.v_dia_tresuno = true)
        : (this.val.v_dia_tresuno = false);
      !this.plan.dia_dosocho_pnh
        ? (this.val.v_dia_dosocho = true)
        : (this.val.v_dia_dosocho = false);
      if (
        this.val.v_salario_qnal ||
        this.val.v_falta_just ||
        this.val.v_falta_injust ||
        this.val.v_permiso ||
        this.val.v_permiso_falle ||
        this.val.v_permiso_naci ||
        this.val.v_hora_tie_ext ||
        this.val.v_tie_ext ||
        this.val.v_doble_turno ||
        this.val.v_dia_festivo ||
        this.val.v_dia_tresuno ||
        this.val.v_dia_dosocho
      ) {
        Snackbar.show({
          text: "Por favor llene todos los campos",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        console.log("validacion de form trabajo retorno true");
        return true;
      }
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerPlan();
  },
  data() {
    return {
      msg: "Inicio",
      plan: {
        nombre_pln: null,
        salario_qnal_pnh: null,
        falta_just_pnh: null,
        falta_injust_pnh: null,
        permiso_pnh: null,
        permiso_falle_pnh: null,
        permiso_naci_pnh: null,
        hora_tie_ext_pnh: null,
        tie_ext_pnh: null,
        doble_turno_pnh: null,
        dia_festivo_pnh: null,
        dia_tresuno_pnh: null,
        dia_dosocho_pnh: null
      },
      val: {
        v_salario_qnal: null,
        v_falta_just: null,
        v_falta_injust: null,
        v_permiso: null,
        v_permiso_falle: null,
        v_permiso_naci: null,
        v_hora_tie_ext: null,
        v_tie_ext: null,
        v_doble_turno: null,
        v_dia_festivo: null,
        v_dia_tresuno: null,
        v_dia_dosocho: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// PlanesEditar.vue?30f55084